import { useEffect } from 'react';
import useDebounce from '../useDebounce/useDebounce.js';

const emptyArr = [];
const emptyObj = {};
const useWindowSize = (options = emptyObj) => {
  const {
    wait,
    leading,
    initialWidth = 0,
    initialHeight = 0
  } = options;
  const [size, setDebouncedSize] = useDebounce(typeof window === 'undefined' ? [initialWidth, initialHeight] : [window.innerWidth, window.innerHeight], wait, leading);
  useEffect(() => {
    const setSize = () => setDebouncedSize([window.innerWidth, window.innerHeight]);
    window.addEventListener('resize', setSize);
    window.addEventListener('orientationchange', setSize);
    return () => {
      window.removeEventListener('resize', setSize);
      window.removeEventListener('orientationchange', setSize);
    };
  }, emptyArr);
  return size;
};

export default useWindowSize;
